(function () {
    'use strict';

    angular
        .module('elogbooksDirectives')
        .directive('elbEventFeed', ElogbooksEventFeed);

    ElogbooksEventFeed.$inject = [];

    function ElogbooksEventFeed () {
        return {
            restrict: 'AE',
            require: ['templatePath'],
            scope: {
                messageCollectionResponse: '=?',
                eventCollectionResponse: '=?',
                fileCollectionResponse: '=?',
                taskResponse: '=?',
                templatePath: '@',
                showFeed: '=?',
                isHelpdesk: '=',
                contactsLink: '=',
                auditTrailState: '=?',
                prefix: '=?'
            },
            templateUrl: '/modules/directives/elb-event-feed/event-feed.html',
            controller: ElogbooksEventFeedController,
            controllerAs: 'vm'
        };
    }

    ElogbooksEventFeedController.$inject = ['$scope', 'eventFeed', 'apiClient', 'messenger', '$state', '$uibModal', '$sce'];

    function ElogbooksEventFeedController ($scope, eventFeed, apiClient, messenger, $state, $uibModal, $sce) {
        var vm = this;
        vm.messageCollectionResponse = $scope.messageCollectionResponse;
        vm.eventCollectionResponse = $scope.eventCollectionResponse;
        vm.fileCollectionResponse = $scope.fileCollectionResponse;
        vm.task = $scope.taskResponse;
        vm.templatePath = $scope.templatePath;
        vm.showFeed = typeof $scope.showFeed === 'undefined' ? true : !!$scope.showFeed;
        vm.isHelpdesk = $scope.isHelpdesk;
        vm.contactsLink = $scope.contactsLink;
        vm.auditTrailState = getAuditTrailState($scope.auditTrailState);
        vm.isCollapsed = true;
        vm.sending = false;
        vm.data = { body: null };
        vm.messageForm = null;
        vm.events = [];
        vm.messages = [];
        vm.files = [];
        vm.feed = [];
        vm.$sce = $sce;
        vm.isPaginated = vm.eventCollectionResponse ? vm.eventCollectionResponse.pages > 1 : false;
        vm.prefix = $scope.prefix;

        vm.submit = submitAction;
        vm.translatedEventString = translatedEventString;
        vm.canCreateMessage = canCreateMessage;
        vm.canCreateAndNotify = canCreateAndNotify;
        vm.isAuditTrailLoading = isAuditTrailLoading;
        vm.hasAuditTrailContent = hasAuditTrailContent;
        vm.hasAllTab = hasAllTab;
        vm.showResourceTab = showResourceTab;
        vm.hasResourceError = hasResourceError;
        vm.hasAnyResourceError = hasAnyResourceError;

        loadFeed();

        $scope.$watchGroup([
            'messageCollectionResponse',
            'eventCollectionResponse',
            'fileCollectionResponse'
        ], function (newValues, oldValues) {
            if (newValues === oldValues) {
                return;
            }

            vm.messageCollectionResponse = $scope.messageCollectionResponse;
            vm.eventCollectionResponse = $scope.eventCollectionResponse;
            vm.fileCollectionResponse = $scope.fileCollectionResponse;

            loadFeed();
        });

        $scope.$watch('auditTrailState', function (auditTrailState) {
            vm.auditTrailState = getAuditTrailState(auditTrailState);
        });

        function loadFeed() {
            eventFeed.setMessageCollectionResponse(vm.messageCollectionResponse);
            eventFeed.setEventCollectionResponse(vm.eventCollectionResponse);
            eventFeed.setFileCollectionResponse(vm.fileCollectionResponse);
            eventFeed.getFeed(function(feed, more) {
                if (more !== undefined && !more) {
                    vm.events = eventFeed.extract(feed, 'event');
                    vm.messages = eventFeed.extract(feed, 'message');
                    vm.files = eventFeed.extract(feed, 'file');
                    vm.feed = eventFeed.removeEvents(feed);
                }
            }, vm.isPaginated);
        }

        function canCreateMessage() {
            return !!(vm.messageCollectionResponse && vm.messageCollectionResponse.getLink && vm.messageCollectionResponse.getLink('create'));
        }

        function canCreateAndNotify() {
            return !!(vm.messageCollectionResponse && vm.messageCollectionResponse.getLink && vm.messageCollectionResponse.getLink('createAndNotify'));
        }

        function isAuditTrailLoading() {
            return isResourceLoading('events')
                || isResourceLoading('messages')
                || (!hasResourceError('events') && !hasResourceError('messages') && !vm.feed);
        }

        function hasAuditTrailContent() {
            return !!(vm.messageCollectionResponse || vm.eventCollectionResponse || hasResourceError('events') || hasResourceError('messages'));
        }

        function hasAllTab() {
            return !!(vm.messageCollectionResponse || vm.eventCollectionResponse || hasResourceError('events') || hasResourceError('messages'));
        }
        function showResourceTab(type) {
            if (type === 'events') {
                return !!(vm.eventCollectionResponse || hasResourceError('events'));
            }

            if (type === 'messages') {
                return !!(vm.messageCollectionResponse || hasResourceError('messages'));
            }

            return false;
        }

        function hasResourceError(type) {
            return !!(vm.auditTrailState[type] && vm.auditTrailState[type].error);
        }

        function hasAnyResourceError() {
            return hasResourceError('events') || hasResourceError('messages');
        }

        function isResourceLoading(type) {
            return !!(vm.auditTrailState[type] && vm.auditTrailState[type].loading);
        }

        function getAuditTrailState(auditTrailState) {
            var state = auditTrailState || {};

            state.events = state.events || { loading: false, error: false };
            state.messages = state.messages || { loading: false, error: false };

            return state;
        }

        function submitAction (form, notify) {
            if (!canCreateMessage()) {
                vm.sending = false;
                return;
            }

            vm.sending = true;
            vm.messageForm = form;

            if (typeof notify === 'undefined') {
                notify = false;
            } else if (notify === true) {
                var contactsModal = $uibModal.open({
                    templateUrl: '/modules/common/contacts/contacts.html',
                    controller: ['contactsCollectionResponse', '$uibModalInstance', 'lodash', '$translate', 'elbSettings', 'entityName', 'userManager', function(contactsCollectionResponse, $uibModalInstance, lodash, $translate, elbSettings, entityName, userManager) {
                        var vm = this;
                        vm.config = {
                            entityName: entityName,
                            notifyUpdate: true
                        };
                        vm.contactCollectionResponse = contactsCollectionResponse;
                        vm.contacts = contactsCollectionResponse.contacts;

                        if(userManager.hasPermission('site_permission_notify_updates')) {
                            vm.contactCollectionResponse.contacts.push({
                                name: $translate.instant('HELPDESK'),
                                email: elbSettings.getSetting('general_helpdesk_email').value,
                                deletable: false,
                                translatable: true,
                                type: 'HELPDESK',
                                shared: false,
                            });
                        }

                        vm.notifyContacts = function() {
                            const contacts = [];

                            vm.contactCollectionResponse.contacts.forEach(contact => {
                                const existingContact = contacts.filter(c => c.email === contact.email);

                                if (contact.checked && !existingContact.length) {
                                    contacts.push({
                                        name: contact.name,
                                        email: contact.email,
                                        shared: contact.isShared,
                                        type: contact.type
                                    });
                                }

                                if (contact.additionalEmail && contact.additionalEmail.length > 0) {
                                    contact.additionalEmail.forEach(email => {
                                        const existingAddress = contacts.filter(c => c.email === email.value);

                                        if (email.value !== contact.email && email.checked && !existingAddress.length) {
                                            contacts.push({
                                                name: contact.name,
                                                email: email.value,
                                                shared: email.isShared,
                                                type: contact.type
                                            });
                                        }
                                    });
                                }
                            });

                            $uibModalInstance.close(contacts);
                        };

                        vm.close = $uibModalInstance.dismiss;
                    }],
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        contactsCollectionResponse: function() {
                            return apiClient.get(vm.contactsLink).then(function(response) {
                                return response;
                            });
                        },
                        entityName: function() {
                            return vm.templatePath.indexOf('job') > -1 ? 'JOB' : 'QUOTE';
                        }
                    }
                });

                contactsModal.result.then(function (contacts) {
                    vm.data.updateRecipients = contacts;

                    return apiClient.create(vm.messageCollectionResponse.getLink('create'), vm.data).then(function (response) {
                        vm.sending = false;

                        if (response) {
                            $state.reload();
                        } else {
                            messenger.error('REQUEST_ERROR');
                        }
                    });
                });

                contactsModal.closed.then(function() {
                    vm.sending = false;
                });
            }

            if (!notify) {
                return apiClient.create(vm.messageCollectionResponse.getLink('create'), vm.data).then(function (response) {
                    vm.sending = false;

                    if (response) {
                        $state.reload();
                    } else {
                        messenger.error('REQUEST_ERROR');
                    }
                });
            }
        }

        function translatedEventString(item) {
            let eventKey;

            if (item.metadata && item.metadata.system_message) {
                eventKey = item.metadata.system_message;
            } else if (item._links['buddiedForUser']) {
                eventKey = item.type + '_buddied';
            } else {
                eventKey = item.type;
            }

            if (!item._links['user']) {
                eventKey += '_system';
            }

            eventKey += '_action';

            return eventKey.toUpperCase();
        }
    }
})();
